<template>
  <div>
    <Label :required="required" :label="label" :name="name"/>
    <Multiselect
      :options="options"
      label="name"
      :multiple="multiple"
      v-model="selected"
      :searchable="searchable"
      :closeOnSelect="closeOnSelect"
      :placeholder="placeholder"
      :limit="(limit>1)?limit:undefined"
      @input="handleValueChange"
      :showLabels="false"
      :options-limit="300"
      :loading="isLoading"
      @search-change="asyncFind"
      :track-by="(multiple)?'value':undefined"
    />
  </div>
</template>

<script>
  // TODO replace vue-select by vue-multiselect
  import { validatorComponent } from './validatorComponentMixin';
  import i18n from './i18n';
  import Multiselect from 'vue-multiselect'
  import axios from 'axios'

  import 'vue-multiselect/dist/vue-multiselect.min.css';

  export default {
    name: 'selectMultiple',
    components: {
      Multiselect,
    },
    mixins: [validatorComponent, i18n.mixin],
    props: {
      options: {
        type: Array,
        required: true
      },
      value: {
        type: String,
      },
      placeholder: {
        type: String,
        default: '',
      },
      validationLabel: String,
      name: String,
      searchable: Boolean,
      ajax: Boolean,
      ajaxUrl: String,
      closeOnSelect: Boolean,
      multiple: Boolean,
      limit: Number,
    },
    data: function() {
      return {
        selected: undefined,
        isLoading: false,
        isDownloaded: false,
      }
    },
    methods: {
      asyncFind (query) {
        if(this.isDownloaded || this.isLoading) {
          return;
        }
        if(this.ajax && this.ajaxUrl && this.ajaxUrl.indexOf('https://') > -1) {
          this.isLoading = true
          axios.get(this.ajaxUrl).then(response => {
            this.options = response.data;
            this.isLoading = false;
            this.isDownloaded = true;
          })
        }
      },
      handleValueChange (val) {
        console.log(val);
        // const value = val ? val[VALUE_COL_NAME] : null
        // this.selected = val
        if(this.multiple) {
          this.$emit('input', val.map((v)=>v.value).join(':'))
        } else {
          this.$emit('input', val.value)
        }
      },
    }
  }
</script>
